module.exports = __webpack_public_path__ + "img/steam.3d7ce930.svg";